function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoNFT = require('../../../../../lib/saito/ui/saito-nft/saito-nft');
var ListingFieldEdit = require('./listing-field-edit');
var returnStoreWeb3Tickers = ListingFieldEdit.returnStoreWeb3Tickers,
  requestStoreWeb3Tickers = ListingFieldEdit.requestStoreWeb3Tickers;
var RentalListingTemplate = require('./rental-listing.template');
var _require = require('../purchase-service'),
  yieldForPaint = _require.yieldForPaint;
var _require2 = require('../listing-approval'),
  isAutoSubmitListings = _require2.isAutoSubmitListings,
  markStoreWeb3Active = _require2.markStoreWeb3Active,
  scheduleSubmitAfterListingConfirmed = _require2.scheduleSubmitAfterListingConfirmed;
var RentalListingOverlay = /*#__PURE__*/function () {
  function RentalListingOverlay(app, mod) {
    _classCallCheck(this, RentalListingOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.field_edit = new ListingFieldEdit(app, mod);
    this.create_nft_overlay = null;
    this.onBack = null;
    this.phase = 'info';
    this.listing_busy = false;
    this.defaults = {};
    // Source Vault rental NFT (vault-nft-rental) — never listed or modified.
    this.source_nft = null;
    this.rental_nft = null;
    this.file_id = '';
    this.source_name = '';
    this.pending_nft_id = null;
    this.pending_nft_signature = null;
    this.pending_nft_tx = null;
    this.form = {
      price: '1',
      web3_ticker: 'SAITO',
      web3_amount: '1',
      duration_hours: 1,
      rights: 'all',
      amount: 1,
      title: '',
      description: ''
    };
  }
  return _createClass(RentalListingOverlay, [{
    key: "escapeHtml",
    value: function escapeHtml() {
      var _this$app;
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.browser) !== null && _this$app !== void 0 && _this$app.escapeHTML) {
        return this.app.browser.escapeHTML(String(value));
      }
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  }, {
    key: "returnMediaHtml",
    value: function returnMediaHtml(nft) {
      if (nft !== null && nft !== void 0 && nft.image) {
        var _this$app2, _this$app2$isSafeMedi;
        if ((_this$app2 = this.app) !== null && _this$app2 !== void 0 && (_this$app2 = _this$app2.browser) !== null && _this$app2 !== void 0 && (_this$app2$isSafeMedi = _this$app2.isSafeMediaUrl) !== null && _this$app2$isSafeMedi !== void 0 && _this$app2$isSafeMedi.call(_this$app2, nft.image)) {
          return RentalListingTemplate.mediaImage(this.escapeHtml(nft.image));
        }
        return '';
      }
      var text = (nft === null || nft === void 0 ? void 0 : nft.text) || (nft === null || nft === void 0 ? void 0 : nft.json) || (nft === null || nft === void 0 ? void 0 : nft.description) || (nft === null || nft === void 0 ? void 0 : nft.title) || 'Store Rental NFT';
      return RentalListingTemplate.mediaText(this.escapeHtml(text));
    }

    /**
     * Vault protected-file fields from the selected NFT's mint transaction
     * (tx.msg.data). Fetches the mint tx via SaitoNFT when not already attached.
     * Returns null if the transaction cannot be loaded — never consults Vault.
     */
  }, {
    key: "resolveSourceVaultData",
    value: function () {
      var _resolveSourceVaultData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(nft) {
        var _nft$tx$returnMessage, _nft$tx;
        var data, nft_type;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (nft) {
                _context.n = 1;
                break;
              }
              return _context.a(2, null);
            case 1:
              if (!(!nft.tx && typeof nft.fetchTransaction === 'function')) {
                _context.n = 2;
                break;
              }
              _context.n = 2;
              return new Promise(function (resolve) {
                var settled = false;
                var finish = function finish() {
                  if (!settled) {
                    settled = true;
                    resolve();
                  }
                };
                nft.fetchTransaction(finish);
                setTimeout(finish, 8000);
              });
            case 2:
              if (nft.tx) {
                _context.n = 3;
                break;
              }
              return _context.a(2, null);
            case 3:
              if (typeof nft.buildNFTData === 'function') {
                nft.buildNFTData(nft.tx);
              }
              data = ((_nft$tx$returnMessage = (_nft$tx = nft.tx).returnMessage) === null || _nft$tx$returnMessage === void 0 || (_nft$tx$returnMessage = _nft$tx$returnMessage.call(_nft$tx)) === null || _nft$tx$returnMessage === void 0 ? void 0 : _nft$tx$returnMessage.data) || {};
              nft_type = (typeof nft.returnType === 'function' ? nft.returnType() : '') || nft.nft_type || '';
              return _context.a(2, {
                link: data.link != null ? String(data.link) : '',
                nft_type: String(nft_type || ''),
                filename: data.filename != null ? String(data.filename) : '',
                file_id: data.file_id != null ? String(data.file_id) : '',
                file_access_script: data.file_access_script != null ? typeof data.file_access_script === 'string' ? data.file_access_script : JSON.stringify(data.file_access_script) : ''
              });
          }
        }, _callee);
      }));
      function resolveSourceVaultData(_x) {
        return _resolveSourceVaultData.apply(this, arguments);
      }
      return resolveSourceVaultData;
    }()
  }, {
    key: "returnSourceName",
    value: function returnSourceName(nft) {
      var _nft$tx2, _nft$tx2$returnMessag;
      var data = (nft === null || nft === void 0 || (_nft$tx2 = nft.tx) === null || _nft$tx2 === void 0 || (_nft$tx2$returnMessag = _nft$tx2.returnMessage) === null || _nft$tx2$returnMessag === void 0 || (_nft$tx2$returnMessag = _nft$tx2$returnMessag.call(_nft$tx2)) === null || _nft$tx2$returnMessag === void 0 ? void 0 : _nft$tx2$returnMessag.data) || {};
      return data.filename || data.file_name || (nft === null || nft === void 0 ? void 0 : nft.title) || (nft === null || nft === void 0 ? void 0 : nft.id) || 'Protected file';
    }
  }, {
    key: "normalizeHours",
    value: function normalizeHours(raw) {
      var hours = parseInt(raw, 10);
      if (!Number.isFinite(hours) || hours < 1) {
        hours = 1;
      }
      if (hours > 24) {
        hours = 24;
      }
      return hours;
    }
  }, {
    key: "normalizeAmount",
    value: function normalizeAmount(raw) {
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000;
      var amount = parseInt(raw, 10);
      if (!Number.isFinite(amount) || amount < 1) {
        amount = 1;
      }
      if (amount > max) {
        amount = max;
      }
      return amount;
    }
  }, {
    key: "parsePriceInput",
    value: function parsePriceInput(raw) {
      var cleaned = String(raw || '').replace(/SAITO/gi, '').trim().replace(/[^\d.]/g, '');
      var firstDot = cleaned.indexOf('.');
      if (firstDot !== -1) {
        cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '');
      }
      if (!cleaned || cleaned === '.' || !Number.isFinite(Number(cleaned))) {
        return null;
      }
      return cleaned;
    }
  }, {
    key: "formatPriceDisplay",
    value: function formatPriceDisplay(price) {
      var _this$form;
      var ticker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ((_this$form = this.form) === null || _this$form === void 0 ? void 0 : _this$form.web3_ticker) || 'SAITO';
      var currency = String(ticker || 'SAITO').trim().toUpperCase() || 'SAITO';
      return "".concat(price, " ").concat(currency);
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _ref,
          _ref$source_nft,
          source_nft,
          _ref$master_nft,
          master_nft,
          _ref$defaults,
          defaults,
          _ref$phase,
          phase,
          vault_data,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref$source_nft = _ref.source_nft, source_nft = _ref$source_nft === void 0 ? null : _ref$source_nft, _ref$master_nft = _ref.master_nft, master_nft = _ref$master_nft === void 0 ? null : _ref$master_nft, _ref$defaults = _ref.defaults, defaults = _ref$defaults === void 0 ? {} : _ref$defaults, _ref$phase = _ref.phase, phase = _ref$phase === void 0 ? null : _ref$phase;
              this.defaults = defaults || {};
              // master_nft kept as alias for older callers.
              this.source_nft = (source_nft === null || source_nft === void 0 ? void 0 : source_nft.nft) || source_nft || (master_nft === null || master_nft === void 0 ? void 0 : master_nft.nft) || master_nft || this.source_nft;
              if (this.source_nft) {
                _context2.n = 1;
                break;
              }
              siteMessage('Select a Vault rental NFT first.', 3000);
              if (typeof this.onBack === 'function') {
                this.onBack(_objectSpread(_objectSpread({}, this.defaults), {}, {
                  listing_mode: 'rent'
                }));
              }
              return _context2.a(2);
            case 1:
              if (this.file_id) {
                _context2.n = 4;
                break;
              }
              _context2.n = 2;
              return this.resolveSourceVaultData(this.source_nft);
            case 2:
              vault_data = _context2.v;
              if (vault_data) {
                _context2.n = 3;
                break;
              }
              siteMessage('Unable to load the NFT transaction. This NFT cannot be listed.', 4000);
              if (typeof this.onBack === 'function') {
                this.onBack(_objectSpread(_objectSpread({}, this.defaults), {}, {
                  listing_mode: 'rent'
                }));
              }
              return _context2.a(2);
            case 3:
              this.file_id = vault_data.file_id || '';
            case 4:
              if (this.file_id) {
                _context2.n = 5;
                break;
              }
              siteMessage('Could not read file_id from this Vault rental NFT.', 4000);
              if (typeof this.onBack === 'function') {
                this.onBack(_objectSpread(_objectSpread({}, this.defaults), {}, {
                  listing_mode: 'rent'
                }));
              }
              return _context2.a(2);
            case 5:
              this.source_name = this.returnSourceName(this.source_nft);
              this.phase = phase || (this.rental_nft ? 'ready' : 'info');
              if (!(this.phase === 'ready')) {
                _context2.n = 6;
                break;
              }
              this.renderReady();
              return _context2.a(2);
            case 6:
              this.renderInfo();
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "renderInfo",
    value: function renderInfo() {
      var _this = this;
      this.phase = 'info';
      var view = {
        sourceName: this.escapeHtml(this.source_name),
        priceDisplay: this.formatPriceDisplay(this.form.price),
        durationHours: this.form.duration_hours,
        amount: this.form.amount
      };
      this.overlay.show(RentalListingTemplate.infoTemplate(view), function () {
        var _this$defaults;
        if (typeof ((_this$defaults = _this.defaults) === null || _this$defaults === void 0 ? void 0 : _this$defaults.callback) === 'function') {
          _this.defaults.callback({
            status: 'cancelled'
          });
        }
      });
      this.attachInfoEvents();
    }
  }, {
    key: "renderReady",
    value: function renderReady() {
      var _nft$getTotalAmount,
        _this$app3,
        _this$app3$returnIden,
        _this2 = this;
      this.phase = 'ready';
      var nft = this.rental_nft;
      var nftId = (nft === null || nft === void 0 ? void 0 : nft.id) || (nft === null || nft === void 0 ? void 0 : nft.uuid) || '';
      var seller = this.mod.publicKey || '';
      if (!this.form.title) {
        this.form.title = (nft === null || nft === void 0 ? void 0 : nft.title) || 'Rental NFT';
      }
      if (!this.form.description) {
        this.form.description = (nft === null || nft === void 0 ? void 0 : nft.description) || '';
      }
      var minted = Number((nft === null || nft === void 0 || (_nft$getTotalAmount = nft.getTotalAmount) === null || _nft$getTotalAmount === void 0 ? void 0 : _nft$getTotalAmount.call(nft)) || (nft === null || nft === void 0 ? void 0 : nft.amount) || this.form.amount) || this.form.amount;
      this.form.amount = this.normalizeAmount(minted, minted);
      var view = {
        nftIdenticon: ((_this$app3 = this.app) === null || _this$app3 === void 0 || (_this$app3 = _this$app3.keychain) === null || _this$app3 === void 0 || (_this$app3$returnIden = _this$app3.returnIdenticon) === null || _this$app3$returnIden === void 0 ? void 0 : _this$app3$returnIden.call(_this$app3, nftId || seller)) || '',
        listingTitle: this.escapeHtml(this.form.title),
        description: this.escapeHtml(this.form.description),
        priceDisplay: this.formatPriceDisplay(this.form.price),
        durationHours: this.form.duration_hours,
        rights: this.form.rights || 'all',
        amount: this.form.amount,
        createdDate: new Date().toLocaleDateString(),
        mediaHtml: this.returnMediaHtml(nft)
      };
      this.listing_busy = false;
      this.overlay.show(RentalListingTemplate.readyTemplate(view), function () {
        var _this2$defaults;
        if (typeof ((_this2$defaults = _this2.defaults) === null || _this2$defaults === void 0 ? void 0 : _this2$defaults.callback) === 'function') {
          _this2.defaults.callback({
            status: 'cancelled'
          });
        }
      });
      this.attachReadyEvents();
    }
  }, {
    key: "attachInfoEvents",
    value: function attachInfoEvents() {
      var _root$querySelector,
        _this3 = this,
        _root$querySelector2,
        _root$querySelector3;
      var root = document.querySelector('.rental-listing.info');
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('[data-field="duration"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('change', function (e) {
        _this3.form.duration_hours = _this3.normalizeHours(e.target.value);
      });
      (_root$querySelector2 = root.querySelector('[data-field="rights"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('change', function (e) {
        _this3.form.rights = e.target.value || 'all';
      });
      var amountInput = root.querySelector('input[data-field="amount"]');
      if (amountInput) {
        amountInput.addEventListener('change', function (e) {
          _this3.form.amount = _this3.normalizeAmount(e.target.value);
          e.target.value = String(_this3.form.amount);
        });
      }
      var priceInput = root.querySelector('input[data-field="price"]');
      if (priceInput) {
        priceInput.addEventListener('focus', function () {
          priceInput.value = _this3.parsePriceInput(priceInput.value) || String(_this3.form.price);
        });
        priceInput.addEventListener('blur', function () {
          var cleaned = _this3.parsePriceInput(priceInput.value);
          if (!cleaned) {
            priceInput.value = _this3.formatPriceDisplay(_this3.form.price);
            return;
          }
          _this3.form.price = cleaned;
          priceInput.value = _this3.formatPriceDisplay(cleaned);
        });
      }
      (_root$querySelector3 = root.querySelector('[data-action="create"]')) === null || _root$querySelector3 === void 0 || _root$querySelector3.addEventListener('click', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
          var cleaned;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                e.preventDefault();
                if (priceInput) {
                  cleaned = _this3.parsePriceInput(priceInput.value);
                  if (cleaned) {
                    _this3.form.price = cleaned;
                  }
                }
                _context3.n = 1;
                return _this3.openCreateNft();
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "attachReadyEvents",
    value: function attachReadyEvents() {
      var _root$querySelector4,
        _this4 = this,
        _root$querySelector5,
        _root$querySelector6,
        _root$querySelector7;
      var root = document.querySelector('.listing-detail.rental-ready');
      if (!root) {
        return;
      }

      // Duration / rights / amount are fixed after mint — only presentation + listing price/title/desc.

      (_root$querySelector4 = root.querySelector('[data-edit="title"]')) === null || _root$querySelector4 === void 0 || _root$querySelector4.addEventListener('click', function (e) {
        e.preventDefault();
        _this4.field_edit.render({
          title: 'Edit Title',
          value: _this4.form.title,
          placeholder: 'Listing title',
          onSave: function onSave(raw) {
            var next = String(raw || '').trim();
            if (!next) {
              return false;
            }
            _this4.form.title = next;
            var el = root.querySelector('[data-field="title"]');
            if (el) {
              el.textContent = next;
            }
            return true;
          }
        });
      });
      (_root$querySelector5 = root.querySelector('[data-edit="description"]')) === null || _root$querySelector5 === void 0 || _root$querySelector5.addEventListener('click', function (e) {
        e.preventDefault();
        _this4.field_edit.render({
          title: 'Edit Description',
          value: _this4.form.description,
          multiline: true,
          placeholder: 'Describe this rental',
          onSave: function onSave(raw) {
            var next = String(raw !== null && raw !== void 0 ? raw : '').trim();
            _this4.form.description = next;
            var el = root.querySelector('[data-field="description"]');
            if (el) {
              el.textContent = next || 'No description provided.';
            }
            return true;
          }
        });
      });
      (_root$querySelector6 = root.querySelector('[data-edit="price"]')) === null || _root$querySelector6 === void 0 || _root$querySelector6.addEventListener('click', function (e) {
        e.preventDefault();
        requestStoreWeb3Tickers(_this4.app);
        var ticker = String(_this4.form.web3_ticker || 'SAITO').trim().toUpperCase() || 'SAITO';
        _this4.field_edit.render({
          title: 'Edit Rental Price',
          value: String(_this4.form.price),
          placeholder: 'Price',
          tickers: returnStoreWeb3Tickers(_this4.app, ticker),
          ticker: ticker,
          onSave: function onSave(raw, selectedTicker) {
            var cleaned = String(raw || '').trim().replace(/[^\d.]/g, '');
            if (!cleaned) {
              return false;
            }
            var nextTicker = String(selectedTicker || 'SAITO').trim().toUpperCase() || 'SAITO';
            _this4.form.price = cleaned;
            _this4.form.web3_ticker = nextTicker;
            _this4.form.web3_amount = cleaned;
            var el = root.querySelector('[data-field="price"]');
            if (el) {
              el.textContent = _this4.formatPriceDisplay(cleaned, nextTicker);
            }
            return true;
          }
        });
      });
      (_root$querySelector7 = root.querySelector('[data-action="submit"]')) === null || _root$querySelector7 === void 0 || _root$querySelector7.addEventListener('click', /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                e.preventDefault();
                _context4.n = 1;
                return _this4.submitListing();
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    }

    /**
     * Stack-style: hide parent, open shared Create NFT with type locked and
     * rental create_data (Vault protected-file fields + duration / rights)
     * attached for createData → tx_msg.data.
     */
  }, {
    key: "openCreateNft",
    value: function () {
      var _openCreateNft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this$mod$header,
          _this5 = this;
        var vault_data, createNft, CreateNFT, hours, duration_ms;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.resolveSourceVaultData(this.source_nft);
            case 1:
              vault_data = _context5.v;
              if (vault_data) {
                _context5.n = 2;
                break;
              }
              siteMessage('Unable to load the NFT transaction. This NFT cannot be listed.', 4000);
              return _context5.a(2);
            case 2:
              if (!(!vault_data.file_id || !vault_data.link || !vault_data.filename || !vault_data.file_access_script || !vault_data.nft_type)) {
                _context5.n = 3;
                break;
              }
              siteMessage('Vault rental NFT is missing protected-file data (link, nft_type, filename, file_id, or file_access_script).', 5000);
              return _context5.a(2);
            case 3:
              this.file_id = vault_data.file_id;
              this.form.duration_hours = this.normalizeHours(this.form.duration_hours);
              this.form.amount = this.normalizeAmount(this.form.amount);
              this.form.rights = this.form.rights || 'all';
              createNft = ((_this$mod$header = this.mod.header) === null || _this$mod$header === void 0 || (_this$mod$header = _this$mod$header.select_nft_overlay) === null || _this$mod$header === void 0 ? void 0 : _this$mod$header.create_nft_overlay) || null;
              if (!createNft) {
                if (!this.create_nft_overlay) {
                  CreateNFT = require('../../../../../lib/saito/ui/saito-nft/overlays/create-overlay');
                  this.create_nft_overlay = new CreateNFT(this.app, this.mod);
                }
                createNft = this.create_nft_overlay;
              }
              hours = this.form.duration_hours;
              duration_ms = hours * 60 * 60 * 1000;
              this.overlay.hide();
              createNft.render({
                type: 'store-nft-rental',
                quantity: this.form.amount,
                deposit: this.form.amount,
                locked: ['type', 'quantity'],
                create_data: {
                  link: vault_data.link,
                  nft_type: vault_data.nft_type,
                  filename: vault_data.filename,
                  file_id: vault_data.file_id,
                  file_access_script: vault_data.file_access_script,
                  duration_hours: hours,
                  duration_ms: duration_ms,
                  rights: this.form.rights || 'all'
                },
                callback: function callback(result) {
                  if ((result === null || result === void 0 ? void 0 : result.status) === 'created') {
                    _this5.pending_nft_id = result.nft_id || null;
                    _this5.pending_nft_signature = result.signature || null;
                    _this5.pending_nft_tx = result.tx || null;
                    _this5.watchMintTransaction(result.tx);
                    return;
                  }
                  if ((result === null || result === void 0 ? void 0 : result.status) === 'cancelled') {
                    _this5.renderInfo();
                  }
                }
              });
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function openCreateNft() {
        return _openCreateNft.apply(this, arguments);
      }
      return openCreateNft;
    }()
  }, {
    key: "watchMintTransaction",
    value: function watchMintTransaction(tx) {
      var _this6 = this;
      if (!this.mod.transaction_monitor) {
        console.error('Store: transaction_monitor is not initialized');
        this.renderInfo();
        return;
      }
      this.mod.transaction_monitor.render({
        tx: tx,
        title: 'Creating Rental NFT',
        lead: 'Your Store Rental NFT is being broadcast to the Saito network.',
        subtitle: 'Waiting for confirmation...',
        successTitle: 'Rental NFT Confirmed',
        successLead: 'Your rental inventory NFT is confirmed and ready to list.',
        successActionLabel: 'Continue',
        callback: function () {
          var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(result) {
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  if (!((result === null || result === void 0 ? void 0 : result.status) === 'confirmed')) {
                    _context6.n = 2;
                    break;
                  }
                  _context6.n = 1;
                  return _this6.onMintConfirmed();
                case 1:
                  return _context6.a(2);
                case 2:
                  if ((result === null || result === void 0 ? void 0 : result.status) === 'cancelled') {
                    _this6.renderInfo();
                  }
                case 3:
                  return _context6.a(2);
              }
            }, _callee6);
          }));
          function callback(_x4) {
            return _callback.apply(this, arguments);
          }
          return callback;
        }()
      });
    }
  }, {
    key: "onMintConfirmed",
    value: function () {
      var _onMintConfirmed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this7 = this,
          _this$rental_nft$tx,
          _this$rental_nft$tx$r,
          _this$rental_nft$getT,
          _this$rental_nft;
        var nft_list, rec, _iterator, _step, r, data, minted, _t;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.n = 1;
              return this.app.wallet.updateNFTList();
            case 1:
              nft_list = this.app.options.wallet.nfts || [];
              rec = null;
              _iterator = _createForOfIteratorHelper(nft_list);
              _context7.p = 2;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context7.n = 6;
                break;
              }
              r = _step.value;
              if (!(this.pending_nft_signature && r.tx_sig === this.pending_nft_signature)) {
                _context7.n = 4;
                break;
              }
              rec = r;
              return _context7.a(3, 6);
            case 4:
              if (!(this.pending_nft_id && r.id === this.pending_nft_id)) {
                _context7.n = 5;
                break;
              }
              rec = r;
              return _context7.a(3, 6);
            case 5:
              _context7.n = 3;
              break;
            case 6:
              _context7.n = 8;
              break;
            case 7:
              _context7.p = 7;
              _t = _context7.v;
              _iterator.e(_t);
            case 8:
              _context7.p = 8;
              _iterator.f();
              return _context7.f(8);
            case 9:
              this.rental_nft = new SaitoNFT(this.app, this.mod, this.pending_nft_tx || null, rec);
              if (!(!this.rental_nft.tx && typeof this.rental_nft.fetchTransaction === 'function')) {
                _context7.n = 10;
                break;
              }
              _context7.n = 10;
              return new Promise(function (resolve) {
                var settled = false;
                var finish = function finish() {
                  if (!settled) {
                    settled = true;
                    resolve();
                  }
                };
                _this7.rental_nft.fetchTransaction(finish);
                setTimeout(finish, 8000);
              });
            case 10:
              if (typeof this.rental_nft.buildNFTData === 'function' && this.rental_nft.tx) {
                this.rental_nft.buildNFTData(this.rental_nft.tx);
              }

              // Prefer duration/rights from the minted NFT data when present.
              data = ((_this$rental_nft$tx = this.rental_nft.tx) === null || _this$rental_nft$tx === void 0 || (_this$rental_nft$tx$r = _this$rental_nft$tx.returnMessage) === null || _this$rental_nft$tx$r === void 0 || (_this$rental_nft$tx$r = _this$rental_nft$tx$r.call(_this$rental_nft$tx)) === null || _this$rental_nft$tx$r === void 0 ? void 0 : _this$rental_nft$tx$r.data) || this.rental_nft.data || {};
              if (data.duration_hours) {
                this.form.duration_hours = this.normalizeHours(data.duration_hours);
              }
              if (data.rights) {
                this.form.rights = data.rights;
              }
              minted = Number(((_this$rental_nft$getT = (_this$rental_nft = this.rental_nft).getTotalAmount) === null || _this$rental_nft$getT === void 0 ? void 0 : _this$rental_nft$getT.call(_this$rental_nft)) || this.rental_nft.amount || this.form.amount);
              if (Number.isFinite(minted) && minted > 0) {
                this.form.amount = minted;
              }
              this.form.title = this.rental_nft.title || this.form.title || 'Rental NFT';
              this.form.description = this.rental_nft.description || this.form.description || '';
              this.renderReady();
            case 11:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 7, 8, 9]]);
      }));
      function onMintConfirmed() {
        return _onMintConfirmed.apply(this, arguments);
      }
      return onMintConfirmed;
    }()
  }, {
    key: "submitListing",
    value: function () {
      var _submitListing = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this8 = this;
        var root, submitBtn, restore, _this$rental_nft$getT2, _this$rental_nft2, _this$defaults2, max, hours, ticker, listing, tx, _this$mod$main, _this$mod$main$render, _t2;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (this.rental_nft) {
                _context8.n = 1;
                break;
              }
              siteMessage('Create the rental NFT before listing.', 3000);
              return _context8.a(2);
            case 1:
              if (!this.listing_busy) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              root = document.querySelector('.listing-detail.edit.rental-ready');
              submitBtn = root === null || root === void 0 ? void 0 : root.querySelector('[data-action="submit"]');
              if (!(submitBtn !== null && submitBtn !== void 0 && submitBtn.disabled)) {
                _context8.n = 3;
                break;
              }
              return _context8.a(2);
            case 3:
              restore = function restore() {
                _this8.listing_busy = false;
                if (!submitBtn) {
                  return;
                }
                submitBtn.disabled = false;
                submitBtn.removeAttribute('aria-busy');
                submitBtn.textContent = 'List on Store';
              };
              this.listing_busy = true;
              if (!(this.overlay && this.overlay.visible === false)) {
                _context8.n = 4;
                break;
              }
              restore();
              return _context8.a(2);
            case 4:
              if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.setAttribute('aria-busy', 'true');
                submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Preparing listing…';
              }
              _context8.n = 5;
              return yieldForPaint();
            case 5:
              _context8.p = 5;
              this.form.duration_hours = this.normalizeHours(this.form.duration_hours);
              max = Number(((_this$rental_nft$getT2 = (_this$rental_nft2 = this.rental_nft).getTotalAmount) === null || _this$rental_nft$getT2 === void 0 ? void 0 : _this$rental_nft$getT2.call(_this$rental_nft2)) || this.rental_nft.amount || this.form.amount);
              this.form.amount = this.normalizeAmount(this.form.amount, max);
              hours = this.form.duration_hours;
              ticker = String(this.form.web3_ticker || 'SAITO').trim().toUpperCase() || 'SAITO';
              listing = {
                title: this.form.title || this.rental_nft.title || 'Rental NFT',
                description: this.form.description || this.rental_nft.description || '',
                price: this.form.price,
                web3_ticker: ticker,
                web3_amount: String(this.form.price || '').trim(),
                quantity_total: this.form.amount,
                quantity_available: this.form.amount,
                listing_mode: 'rent',
                rental_duration_hours: hours,
                rental_duration_ms: hours * 60 * 60 * 1000,
                rental_rights: this.form.rights || 'all',
                file_id: this.file_id
              };
              this.rental_nft.title = listing.title;
              this.rental_nft.description = listing.description;
              _context8.n = 6;
              return this.mod.createListAssetTransaction(this.rental_nft, listing);
            case 6:
              tx = _context8.v;
              _context8.n = 7;
              return this.app.network.propagateTransaction(tx);
            case 7:
              if (ticker !== 'SAITO' && markStoreWeb3Active(this.app)) {
                (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || (_this$mod$main = _this$mod$main.menu) === null || _this$mod$main === void 0 || (_this$mod$main$render = _this$mod$main.render) === null || _this$mod$main$render === void 0 || _this$mod$main$render.call(_this$mod$main);
              }
              if (typeof ((_this$defaults2 = this.defaults) === null || _this$defaults2 === void 0 ? void 0 : _this$defaults2.callback) === 'function') {
                this.defaults.callback({
                  status: 'listed',
                  tx: tx
                });
                this.defaults.callback = null;
              }
              this.beginListingProgress(tx, listing);
              if (isAutoSubmitListings(this.app)) {
                scheduleSubmitAfterListingConfirmed(this.app, this.mod, tx.signature);
              }
              _context8.n = 9;
              break;
            case 8:
              _context8.p = 8;
              _t2 = _context8.v;
              console.error('Store: rental listing failed', _t2);
              restore();
              alert((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Rental listing failed');
            case 9:
              return _context8.a(2);
          }
        }, _callee8, this, [[5, 8]]);
      }));
      function submitListing() {
        return _submitListing.apply(this, arguments);
      }
      return submitListing;
    }()
  }, {
    key: "beginListingProgress",
    value: function beginListingProgress(tx, listing) {
      var _this9 = this,
        _this$mod$main2;
      if (!this.mod.listing_lifecycle) {
        var ListingLifecycle = require('../listing-lifecycle');
        this.mod.listing_lifecycle = new ListingLifecycle(this.app, this.mod);
      }
      var entry = this.mod.listing_lifecycle.begin({
        nft: this.rental_nft,
        listing: listing,
        listingTx: tx,
        sellerPublicKey: this.mod.publicKey
      });
      this.overlay.close();
      var title = (entry === null || entry === void 0 ? void 0 : entry.title) || (listing === null || listing === void 0 ? void 0 : listing.title) || '';
      var safeTitle = this.escapeHtml(title);
      var lead = safeTitle ? "Your rental listing for <strong>".concat(safeTitle, "</strong> has been broadcast to the Saito network.") : 'Your rental listing has been broadcast to the Saito network.';
      this.mod.transaction_monitor.render({
        tx: tx,
        title: 'Rental Listing Submitted',
        lead: lead,
        successTitle: 'Listing Successful',
        successLead: 'You have successfully added a rental item to your Saito Store.',
        callback: function callback(result) {
          if ((result === null || result === void 0 ? void 0 : result.status) === 'cancelled') {
            var _this9$mod$listing_li, _this9$mod$listing_li2;
            var active = (_this9$mod$listing_li = _this9.mod.listing_lifecycle) === null || _this9$mod$listing_li === void 0 || (_this9$mod$listing_li2 = _this9$mod$listing_li.returnActiveListing) === null || _this9$mod$listing_li2 === void 0 ? void 0 : _this9$mod$listing_li2.call(_this9$mod$listing_li);
            if (active) {
              _this9.mod.listing_lifecycle.dismiss(active.id);
            }
          }
        }
      });
      if ((_this$mod$main2 = this.mod.main) !== null && _this$mod$main2 !== void 0 && _this$mod$main2.openStorefront && this.mod.publicKey) {
        Promise.resolve(this.mod.main.openStorefront(this.mod.publicKey, {
          celebrate: true,
          admin: true
        }))["catch"](function (err) {
          console.warn('Store: openStorefront after rental list failed', (err === null || err === void 0 ? void 0 : err.message) || err);
        });
      }
    }
  }]);
}();
module.exports = RentalListingOverlay;